import logo from "@/assets/LOGO-RETRO-IA.png";

export function DefaultLogoSimple({
  className = "h-12 w-auto",
}: {
  className?: string;
}) {
  return <img src={logo} alt="Retro IA Logo" className={className} />;
}

export function DefaultLogoMinimalista({
  className = "h-12 w-auto",
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 70 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
      </defs>
      <rect x="5" y="5" width="50" height="50" rx="12" fill="url(#grad)" />
      <text
        x="30"
        y="42"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize="28"
        fontWeight="900"
        fill="white"
        textAnchor="middle"
      >
        RI
      </text>
    </svg>
  );
}

export function DefaultLogo({
  className = "h-12 w-auto",
}: {
  className?: string;
}) {
  return <img src={logo} alt="Retro IA Logo" className={className} />;
}
